<template>
    <div>
        <div class="banner">
            <h4>{{ title }}</h4>
        </div>

        <v-form @submit.prevent="create" ref="form">
            <v-row dense>
                <v-col class="d-flex" cols="12" sm="12">
                    <v-autocomplete class="rounded-lg" :items="kind_of_patients" dense item-text="name" item-value="id"
                        :rules="kindPatientRules" outlined color="#086318" v-model="resource.kind_of_donor_id">

                        <template v-slot:label>
                            Tipo de Paciente:
                            <span style="color: red">*</span>
                        </template>
                    </v-autocomplete>
                </v-col>
                <v-col class="d-flex" cols="12" sm="12">
                    <v-text-field class="rounded-lg" color="#41916b" outlined v-model="resource.description"
                        :rules="descriptionRules" dense>
                        <template v-slot:label>
                            Motivo da Não Realização da Entrevista Familiar <span style="color: red;">*</span>
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>
            <v-card-actions class="d-flex justify-end">
                <v-btn 
                class="rounded-lg" 
                color="#e74c3c" 
                text 
                elevation="0" 
                @click="closeDialog()"> 
                    <span>{{$t('buttons.cancel')}}</span>
                </v-btn>

                <v-btn 
                class="rounded-lg"
                text 
                elevation="0" 
                @click="$refs.form.reset()">
                    <span>{{$t('buttons.clean_up')}}</span>
                </v-btn>

                <v-btn 
                class="rounded-lg"
                elevation="0" 
                color="#41916b" 
                type="submit" 
                :loading="loading">
                    <span class="textBtn">{{ btnMessage }}</span>
                    <v-icon color="#FFFFFF" small class="ml-2">mdi-arrow-right</v-icon>
                </v-btn>
            </v-card-actions>
        </v-form>
    </div>
</template>
<script>
import Formatters from '@/utils/Formatters';
import { saveReasonNotFamilyInterview } from "@/service/basic-registrations/ReasonNotFamilyInterviewService";
import FormFieldsService from "@/service/FormFieldsService";
import { mapActions } from "vuex"; 
export default {
    data() {
        return {
            dialog: false,
            descriptionRules: [
                v => !!v || "Campo obrigatório.",
                v => (v && v.toString().length >= 5) || "O campo deve possuir pelo menos 5 caracteres."
            ],
            kindPatientRules: [
                v => !!v || "Campo obrigatório.",
            ],
            loading: false,
            reason: '',
            kind_of_patients: [],
        };
    },

    props: {
        resource: {
            type: Object,
        }
    },

    computed: {
        title() {
            return this.resource.id
                ? 'Atualizar Motivo de Não Realização da Entrevista Familiar'
                : 'Novo Motivo de Não Realização da Entrevista Familiar';
        },

        btnMessage() {
            return this.resource.id
                ? 'Atualizar'
                : 'Salvar';
        },

        radioDescription() {
            return 'Tipo de Paciente'
        }
    },

    mounted() {
        this.loadPatients();
        this.fillForm();
    },

    methods: {
        ...mapActions([
            "changeSnackBarData"
        ]),

        fillForm() {
            if(this.resource.id) {
                this.resource.kind_of_donor_id = parseInt(this.resource.kind_of_donor_id);
            }
        },
        
        async loadPatients() {
          this.kind_of_patients = await FormFieldsService.getKindOfDonor(); 
        },

        create() {
            this.loading = true;
            if (this.$refs.form.validate()) {
                const dados = {
                    description: this.resource.description.toUpperCase(),
                    kind_of_donor_id: this.resource.kind_of_donor_id
                }

                saveReasonNotFamilyInterview(this.resource.id || null, dados).then((response) => {
                    this.loading = false;

                    this.changeSnackBarData({
                        status: true,
                        type: 'success',
                        titleMessage: response.data.message,
                        bodyMessage: '',
                        cardColor: 'success',
                        titleIcon: 'mdi-check-circle',
                    });

                    setTimeout(() => {
                        this.closeSnackBar();
                        this.closeDialog();
                    }, 3000);

                }).catch((err) => {
                    this.loading = false;
                    this.changeSnackBarData({
                        status: true,
                        type: 'erro',
                        titleMessage: this.$t('messages.something_went_wrong'),
                        bodyMessage: Formatters.formatErrorMessage(err),
                        cardColor: 'red',
                        titleIcon: 'mdi-close-circle',
                    });

                    setTimeout(() => {
                        this.closeSnackBar();
                    }, 3000);
                });
            }
        },

        closeDialog() {
            this.resource.description = '';
            this.$refs.form.resetValidation();
            this.$emit("closeDialog");
        },

        closeSnackBar() {
            this.changeSnackBarData({
                status: false,
                type: '',
                titleMessage: '',
                bodyMessage: '',
                cardColor: '',
                titleIcon: '',
            });
        }
    },
};
</script>
<style scoped>
.textBtn {
    font-family: "Poppins";
    color: #ffffff;
}

.card {
    padding: 35px;
}

.banner {
    background: #b3ffab;
    background: -webkit-linear-gradient(to right,
            #41916b,
            #1abc9c);
    background: linear-gradient(to right,
            #41916b,
            #b8e0cd);

    border-radius: 8px;

    margin-bottom: 20px;

    display: flex;
    align-items: center;
}

.banner>h4 {
    color: #ffffff;
    padding: 10px;
}
</style>